import React, { Component } from 'react';
import omit from 'lodash/fp/omit';

const PROPS_TO_OMIT = [
  'iconSize',
  'from',
  'to',
  'addClearBtn',
  'overlayProps',
  'lastSelectedPreset',
  'anchorLabel',
  'buttonType',
];

class Input extends Component {
  getInputProps() {
    return omit(PROPS_TO_OMIT, this.props);
  }
  el = null;
  focus() { this.el.focus(); }
  render() {
    return (
      <input
        className="c-input"
        {...this.getInputProps()}
        ref={(ref) => { this.el = ref; }}
      />
    );
  }
}

export default Input;
